import { Navigate } from "react-router"

export const NotFound = () => <Navigate to="/" />
